import { Interceptor } from "@core/api/interceptors/interceptor";
import { NoTargetInfraError } from "@domain/infra/infra-errors";
import { InfraManager } from "@domain/infra/infra-manager";
import { isNotNil } from "@utils/assert";
import { AxiosRequestConfig } from "axios";

export const addBaseUrlInterceptor: (infraManager: InfraManager) => Interceptor<AxiosRequestConfig> = infraManager => ({
	onFulfilled: config => {
		const targetBaseUrl = infraManager.targetInfra?.apiUrl;
		if (isNotNil(targetBaseUrl)) {
			return {
				...config,
				url: `${targetBaseUrl}${config.url}`,
			};
		}
		return Promise.reject(
			new NoTargetInfraError(`Api calls are forbidden until an infra is targeted. Url was ${config.url}`),
		);
	},
});
